





















import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import {
  getExpenseCategory,
  ExpenseCategory
} from "@/api/cost/expense-categories-api";
import ExpenseCategoryForm from "../components/ExpenseCategoryForm.vue";

@Component({
  components: {
    ExpenseCategoryForm
  }
})
export default class ExpenseCategoryEditPage extends Vue {
  @Prop({ required: true }) expenseCategoryId!: string;

  expenseCategory: ExpenseCategory | null = null;

  saving = false;

  //ロード時の動作、変更の監視
  @Watch("expenseCategoryId", { immediate: true })
  onExpenseCategoryChanged(expenseCategoryId: string) {
    this.initExpenseCategory(expenseCategoryId);
  }

  // APIから値の取得、表示
  async initExpenseCategory(expenseCategoryId: string) {
    this.expenseCategory = await getExpenseCategory(expenseCategoryId);
  }

  goListPage() {
    this.$router.push({ path: "/admin/expense-categories" });
  }

  // APIへ値の保存 (ExpenseCategoryForm内のメソッドにまかせる)
  async saveExpenseCategory() {
    this.saving = true;
    const form = this.$refs["form"] as ExpenseCategoryForm;
    await form
      .submit()
      .then(() => {
        this.goListPage();
      })
      .catch((e: Error) => {
        alert(e.message);
      })
      .finally(() => {
        this.saving = false;
      });
  }
}
